module.exports = __webpack_public_path__ + "static/multiple-location-management-dc42e80f47be4d694242eff07299daf4.png";